import styled from 'styled-components'

export const FooterGridArea = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    color: var(--dashboard-secondary-color);
    font-size: 0.825em;
    display: flex;
    align-items: flex-start;
    margin-top: 10px;

    svg {
        width: 100px;
        opacity: 0.9;
        margin-right: 10px;
        margin-left: 10px;
    }
`

export const InfoText = styled.span`
    flex: 1;
    text-align: center;
`

export const UpdatedAtText = styled.span`
    flex: 1;
    text-align: right;
`
